import { useAuthContext } from '@healthblocks-io/core'

import { useLoginFlow } from '@/modules/auth/hooks/useLoginFlow'

/**
 * Custom hook to handle authentication and share the state across the application
 */
export const useAuthentication = () => {
  const auth = useAuthContext()
  const loginFlow = useLoginFlow()

  const isAuthenticated = !!auth.data.current

  return {
    isAuthenticated,
    ...loginFlow,
  }
}
